export type FieldId = string & { readonly __brand: 'FieldId' };

const semanticFieldIdPattern =
  /^(application|beneficiary|sponsor|household_member|child|interpreter|preparer|document|eligibility)(\.[a-z][a-z0-9_]*[a-z0-9]){2,}$/;

export const isSemanticFieldId = (value: string): value is FieldId => {
  if (!semanticFieldIdPattern.test(value)) {
    return false;
  }

  return value.split('.').every(segment => !/^\d+$/.test(segment));
};

export const defineFieldId = (value: string): FieldId => {
  if (!isSemanticFieldId(value)) {
    throw new Error(`Field ID must be semantic and stable: ${value}`);
  }

  return value;
};
